import { connect } from "react-redux";
import {ResearcherPage} from "../views/ResearcherPage";

const mapStateToProps =(state) => {
    return {
        demographicInformation: state.demographicInformation,
        isResearcher: state.isResearcher
    }
}

export const ResearcherPageConnector = connect(mapStateToProps)(ResearcherPage)